import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrench = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2009_13609)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20 9.9991C20 5.69945 17.2863 2.03402 13.4783 0.621094V19.3771C17.2863 17.9642 20 14.2988 20 9.9991Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 9.9991C0 14.2987 2.71379 17.9642 6.52176 19.3771V0.621094C2.71379 2.03402 0 5.69945 0 9.9991Z",
					fill: "#0052B4"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2009_13609",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFrench);
export { ForwardRef as ReactComponent };
